export default "__VITE_ASSET__CR5iPRwn__"